// extracted by mini-css-extract-plugin
export default {"container":"overview_container__ipLc7","truncate-table":"overview_truncate-table__OsvH-","table-text-faded":"overview_table-text-faded__E1ayL","wrapper":"overview_wrapper__WgBPT","topBar":"overview_topBar__H4YA7","actions":"overview_actions__EbJtz","pagination":"overview_pagination__eZVH1"};
    if(module.hot) {
      // 1793877077014
      var cssReload = require("!../../../../node_modules/.pnpm/css-hot-loader@1.4.4/node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  